import React, { useEffect } from 'react'
import { codeleapWebCache } from '@codeleap/web'
import { CacheProvider } from '@emotion/react'
import { Root } from './src/Root'
import { AppStatus } from './src/redux'
import { PermissionUtils } from './src/utils'
import { APIClient } from './src/services'
import { Redirect } from './src/components'
import { WrapPageElementBrowserArgs } from 'gatsby'
import { TypeGuards } from '@codeleap/types'

import { analytics } from './src/services/analytics/segment'
import { createLog } from './src/utils/utility'

const DEBUG = false
const log = createLog('gatsby-browser', DEBUG)

export const wrapRootElement = ({ element }) => {
  log('wrapRootElement')
  return (
    <CacheProvider value={codeleapWebCache}>
      <Root>{element}</Root>
    </CacheProvider>
  )
}

const ShowAppStatus = () => {
  log('ShowAppStatus rendered')
  useEffect(() => {
    log('ShowAppStatus useEffect')
    AppStatus.set('splash')
    return () => {
      log('ShowAppStatus cleanup')
      AppStatus.set('idle')
    }
  }, [])

  return null
}

export const wrapPageElement = ({ element, props }: WrapPageElementBrowserArgs) => {
  const isRoutePublic = PermissionUtils.isRoutePublic(props.location.pathname)
  const firebaseUser = APIClient.Session.useFirebaseUser()
  const user = APIClient.Session.useProfile()

  if (isRoutePublic) return element

  const loadingVars = [user.isLoading]
  log('loadingVars', loadingVars)

  const loading = loadingVars.some(Boolean)

  if (loading || TypeGuards.isUndefined(firebaseUser)) {
    log('loading')
    return <ShowAppStatus />
  }

  const hasUser = [firebaseUser?.uid, user.data?.id].every(Boolean)
  log('hasUser', hasUser)

  if (!hasUser) {
    return <Redirect to="/auth/login/" />
  }

  return element
}

export const onClientEntry = async () => {
  log('onClientEntry')

  window.addEventListener('unhandledrejection', event => {
    const error = event.reason
    if (error?.name === 'ChunkLoadError') {
      const reloadKey = `chunk_reload_${window.location.pathname}`
      if (!sessionStorage.getItem(reloadKey)) {
        sessionStorage.setItem(reloadKey, '1')
        window.location.reload()
      }
    }
  })
}

// Gatsby fires this for the initial route as well as every navigation, so it is the only
// page-view call site — eagerly initialising and firing a bare `page()` in `onClientEntry`
// double-counted the first view and loaded the Segment bundle for users the analytics
// guard excludes. The analytics client loads the SDK lazily on this first allowed call
// instead.
export const onRouteUpdate = ({ location }) => {
  log('onRouteUpdate', location.pathname)
  analytics.page({
    path: location.pathname,
    url: location.href
  })
}
